<template>
	<div id="loadpassword">
		<div class="container">
			<div class="form-horizontal">
				<p>ご登録頂いたユーザー名またはメールアドレスを入力してください。パスワード再登録のご案内をメールにてお送り致します。</p>
				<p>ユーザー名が不明の場合も、このメール内でご確認頂けます。 </p>
				<div v-if="defaultCaution" class="alert alert-danger" role="alert">{{defaultCaution}}</div>
				<div class="form-group">
					<label for="loginid" class="control-label">ユーザー名またはメールアドレス</label>
					<div>
						<input type="text" class="form-control" id="loginid" v-model="username">
					</div>
				</div>
				<div v-if="!flagSuccess" class="flexrow">
					<Button
						label="新しいパスワードを取得"
						@click-button="actionSubmit"
					></Button>
				</div>
				<div v-else>
					<div class="alert alert-danger" role="alert">確認用のリンクをメールで送信しましたので、ご確認ください。</div>
				</div>
			</div>
			<div class="inline-link">
				<a href="#" @click.prevent="goBack">戻る</a>
			</div>
		</div>
	</div>

</template>
<script>
	import Button from '@/components/common/Button';

	export default {
		mixins: [],
		components: {
			Button
		},
		props: {
		},
		data() {
			return {
				defaultCaution: '',
				username: '',
				flagSuccess: false
			};
		},
		computed: {
		},
		methods: {
			async actionSubmit() {
				this.defaultCaution = '';
				const rslt = await this.$store.dispatch('commonStore/lostPassword', {un:this.username});
				if(rslt && rslt.payload && rslt.payload.status == 1) {
					this.flagSuccess = true;
				} else {
					this.defaultCaution = '無効なユーザー名またはメールアドレスです。';
				}
			},
			goBack() {
				this.$router.back();
			},
			clickLogin() {
				this.$router.push('/login');
			}
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#loadpassword {
		display: flex;
		justify-content: center;
		align-items: center;

		margin: 0 auto;
		padding: 0 8px 0;
		height: 100vh;

		.container {
			width: auto;
			max-width: 400px;
			
			.form-horizontal {
				max-width: 240px;
				margin-left: auto;
				margin-right: auto;
				.form-group {
					margin-left: 0;
					margin-right: 0;
				}
				.flexrow {
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
			.inline-link {
				margin-top: 3em;
				text-align: center;
			}
		}
	}
</style>

